import React, { useState } from 'react';

const Help = () => {

    const [isOpen, setIsOpen] = useState(true);

    const openPopup = () => {
        document.querySelector('.c_help-popup__video-overlay').classList.add('c_video-open');
    }

    const togglePopup = () => {
        setIsOpen(!isOpen);
    }

    return (
        <>
            <div className="c_help__btn" onClick={togglePopup}>
                <img alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/markers/icon/help.png" />
            </div>
            <div className={isOpen ? "c_help-popup__overlay" : "c_help-popup__overlay c_active"}>
                <img className="c_help-popup__overlay-img" onClick={togglePopup} alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/overlay.png" />
                <div className="c_help-popup">
                    <div className="c_help-popup__body">
                        <div className="c_help-popup__images">
                            <img className="c_help-popup__bg" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/help/bg.png" />
                        </div>
                        <div className="c_help-popup__content">
                            <div className="c_text">
                                <h3 className='c_help-popup__title'>ПОМОЩЬ</h3>
                                <p>Чтобы получить финальную награду, вам нужно выполнить 12 боевых задач, разделённых на три категории. Просто выберите понравившийся объект и примите предлагаемую задачу, после чего отправляйтесь в бой. Задачи можно выполнять в любом порядке. Когда все три стадии подготовки будут пройдены, а награда получена, вам откроется доступ к трём дополнительным задачам, за выполнение которых вы также получите награду. Принять можно только одну задачу единовременно. Задачи выполняются на технике IV уровня и выше в Случайных боях и Генеральных сражениях.</p>
                                <p>На самом деле всё очень просто.  Прогревайте моторы — и давайте отпразднуем вместе!</p>

                            </div>
                            <div className='c_btn__wrap'>
                                <div
                                    className="c_btn"
                                    onClick={togglePopup}
                                >
                                    <img className="c_btn__img" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/btn-color.png" />
                                    <div className="c_btn__text">
                                        ТАК ТОЧНО!
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Help;